/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @author: Richard Scoones @ 20/03/2018
 * @description: Custom simple spinner. Intended to be used inline with input fields
 */
import React from "react";
import BaseSvgIcon from "../../Icon/customIcons/Base";
var TinyLoader = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props),
        React.createElement("g", null,
            React.createElement("ellipse", { transform: "rotate(0, 7, 2)", cx: "7", cy: "2", rx: "2", ry: "2", style: { opacity: 0.3 } },
                React.createElement("animate", { attributeType: "CSS", attributeName: "opacity", from: "1", to: "0", dur: "0.6s", repeatCount: "indefinite", begin: "0s" })),
            React.createElement("ellipse", { transform: "rotate(60, 11.3301, 4.5)", cx: "11.3301", cy: "4.5", rx: "2", ry: "2", style: { opacity: 0.3 } },
                React.createElement("animate", { attributeType: "CSS", attributeName: "opacity", from: "1", to: "0", dur: "0.6s", repeatCount: "indefinite", begin: "0.1s" })),
            React.createElement("ellipse", { transform: "rotate(120, 11.3301, 9.5)", cx: "11.3301", cy: "9.5", rx: "2", ry: "2", style: { opacity: 0.3 } },
                React.createElement("animate", { attributeType: "CSS", attributeName: "opacity", from: "1", to: "0", dur: "0.6s", repeatCount: "indefinite", begin: "0.2s" })),
            React.createElement("ellipse", { transform: "rotate(180, 7, 12)", cx: "7", cy: "12", rx: "2", ry: "2", style: { opacity: 0.3 } },
                React.createElement("animate", { attributeType: "CSS", attributeName: "opacity", from: "1", to: "0", dur: "0.6s", repeatCount: "indefinite", begin: "0.3s" })),
            React.createElement("ellipse", { transform: "rotate(240, 2.6699, 9.5)", cx: "2.6699", cy: "9.5", rx: "2", ry: "2", style: { opacity: 0.3 } },
                React.createElement("animate", { attributeType: "CSS", attributeName: "opacity", from: "1", to: "0", dur: "0.6s", repeatCount: "indefinite", begin: "0.4s" })),
            React.createElement("ellipse", { transform: "rotate(300, 2.6699, 4.5)", cx: "2.6699", cy: "4.5", rx: "2", ry: "2", style: { opacity: 0.3 } },
                React.createElement("animate", { attributeType: "CSS", attributeName: "opacity", from: "1", to: "0", dur: "0.6s", repeatCount: "indefinite", begin: "0.5s" })))));
};
export default TinyLoader;
